import { useRepositoryMutation } from '@mews-commander/data-access';
import { fetchCurrentEnterpriseReservationsByReservationIds } from '@mews-commander/legacy-entities/src/actions/reservations';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { RESERVATION_BARE_MINIMUM_EXTENT } from '../../../constants';
import { PurchaseOrderNumberFormKeys, PurchaseOrderNumberFormSchema, PurchaseOrderNumberFormValues } from './types';

export const useChangePurchaseOrderNumberMutation = (reservationIds: Array<string>) => {
    const dispatch = useCommanderThunkDispatch();

    return useRepositoryMutation('reservations', 'updatePurchaseOrderNumber', {
        transformParams: (values: PurchaseOrderNumberFormValues) => {
            const parsedValues = PurchaseOrderNumberFormSchema.parse(values);

            return {
                reservationIds,
                purchaseOrderNumber: parsedValues[PurchaseOrderNumberFormKeys.purchaseOrderNumber],
            };
        },
        onSuccess: async () => {
            await dispatch(
                fetchCurrentEnterpriseReservationsByReservationIds({
                    extent: { ...RESERVATION_BARE_MINIMUM_EXTENT, purchaseOrderNumbers: true },
                    reservationIds,
                })
            );
        },
    });
};
